import React, {useState} from 'react';
import {observer} from "mobx-react";
import {VideoSlidesArenaFiltersIndicatorBox} from './boxes/video-slides-arena-filters-indicator.box';
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {
    VideoSlidesHeaderFilterButtonComponent
} from "../video-slides-header-filter-button/video-slides-header-filter-button.component";
import {IVideoSlidesFilter} from "../../../../../../services/configurations/config-data-sections/arenas.configuration";
import {Check} from "@sparkware/app-utils";


export interface VideoSlidesArenaFiltersIndicatorProps {
    filters: IVideoSlidesFilter[];
}

export const VideoSlidesArenaFiltersIndicator: React.FC<VideoSlidesArenaFiltersIndicatorProps> = observer((props) => {
    const services = useServices();
    const [activeFilter, setActiveFilter] = useState(props.filters[0].translationKey); //just a dumbed down mechanism to mock an active filter so that product can see the active css

    const renderSingleFilter = (filterConfig: IVideoSlidesFilter) => {
        return <VideoSlidesHeaderFilterButtonComponent textTranslationKey={filterConfig.translationKey}
        icon={Check.isNullOrUndefined(filterConfig.icon) ? null : services.theme.currentTheme.icons[filterConfig.icon]}
        isActive={Boolean(activeFilter === filterConfig.translationKey)}
        onClick={setActiveFilter}
        />
    }

    return (
        <VideoSlidesArenaFiltersIndicatorBox>
            {props.filters.map(filterConfig => renderSingleFilter(filterConfig))}
        </VideoSlidesArenaFiltersIndicatorBox>
    );
})